import { UseFormReturn } from "react-hook-form";
import { ErrorMessageComponent } from "../../Common/Input/ErrorMessage/ErrorMessage";
import { PrimeButton } from "../../prime/button";
import { ResetPasswordFormSchemaType } from "./ResetFormSchema";

interface ResetPasswordComponentProps {
  isFetching: boolean;
  onSubmit: (data: any) => Promise<void>;
  useFormProps: UseFormReturn<ResetPasswordFormSchemaType>;
}

export const ResetPasswordComponent = (props: ResetPasswordComponentProps) => {
  const { onSubmit, isFetching, useFormProps } = props;

  return (
    <form onSubmit={useFormProps.handleSubmit(onSubmit)}>
      <div className="mb-6">
        <input
          type="text"
          className={`fp-text-input static ${
            useFormProps.formState.errors.email?.message && `border-red-700`
          }`}
          placeholder="Email"
          autoComplete="email"
          {...useFormProps.register("email")}
          disabled={isFetching}
        />
        <ErrorMessageComponent
          fieldError={useFormProps.formState.errors.email}
        />
      </div>

      <PrimeButton
        size="large"
        type="submit"
        status={isFetching ? "loading" : "default"}
      >
        Continue
      </PrimeButton>
    </form>
  );
};
